import React, { memo } from 'react';
import styled from 'styled-components';
import { ProgressIndicator } from '@oneaudi/unified-web-components';

const StyledProgressIndicator = styled(ProgressIndicator)`
  position: absolute;
  top: 11px;
  left: 11px;
  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    scale: 1.2;
    top: 13px;
    left: 13px;
  }
`;

export const LoadingIndicator = memo(() => (
  <StyledProgressIndicator
    aria-label="Aria-Label"
    colorScheme="colored"
    data-testid="loading-indicator"
    size="sm"
    type="infinite"
    variant="spinner"
  />
));
